import supabase from "../../../shared/database/supabase";
import { ServiceOrderRepository } from "../../../models/service-order/service-order.repository";
import { ServiceOrder } from "../model/service-order";


export const createServiceOrder = async (serviceOrder: ServiceOrder) => {
    try {
        const { data, error } = await supabase.functions.invoke<ServiceOrderRepository>("create-service-order", {
            body: JSON.stringify({
                costumer_id: serviceOrder.costumerId,
                created_by: serviceOrder.createdBy,
            }),
        });

        if (error) {
            console.error("Error calling create-service-order:", error);
            return { data: null, error };
        }
        return { data: data, error: null };
    } catch (err) {
        console.error("Exception in createServiceOrder:", err);
        throw err;
    }
};